import React from 'react'
import axios from 'axios'
import { useRef,useState } from 'react'
import './App.css'
import Latest from './Latest'
import { Route,Routes } from 'react-router'
import Search from './Search'
import { useNavigate } from 'react-router'
import { AppContext } from './Context'


function App() {
  const navigate=useNavigate()
  const inpref=useRef('')
  const[srch,setsearch]=useState([])
  const search=()=>{

    navigate('/search')
    
    axios.post('https://finnewsapi.onrender.com/search',{symbol:inpref.current.value}).then((res)=>{
      
      console.log(res.data);
      const data = Array.isArray(res.data) ? res.data : [res.data];

      setsearch(data)
      

    }).catch(()=>{
      alert('Invalid Ticker')
      inpref.current.value=''
    })

    
  }


  return (
    <div>
      <h1>📈StockPulse India</h1>
      <input ref={inpref} type="text" className='search' placeholder='Enter a ticker (Eg.INFY)' />
      <button className='searchbtn' onClick={search}>Search</button>
      
      <Routes>
        <Route Component={Latest} path='/' ></Route>
        <Route Component={Search} path='/search'></Route>
        
        
      </Routes>
      <AppContext.Provider value={srch}>
              <Search></Search>
      </AppContext.Provider>

      
     
  
    </div>
  )
}

export default App
